import { ANSWER_KINDS, type AnswerKind } from '@/shared/answer-kind';

export type AnswerDraftSource =
    | { kind: 'human' }
    | { kind: 'ai'; originalText: string }
    | { kind: 'template'; originalText: string };

export const createHumanAnswerDraftSource = (): AnswerDraftSource => ({ kind: 'human' });

export const createAiAnswerDraftSource = (originalText: string): AnswerDraftSource => ({
    kind: 'ai',
    originalText,
});

export const createTemplateAnswerDraftSource = (originalText: string): AnswerDraftSource => ({
    kind: 'template',
    originalText,
});

export const createAnswerDraftSourceFromAnswerKind = ({
    answerKind,
    originalText,
}: {
    answerKind?: AnswerKind | null;
    originalText: string;
}): AnswerDraftSource => {
    if (answerKind === ANSWER_KINDS.aiUnchanged || answerKind === ANSWER_KINDS.aiChanged) {
        return createAiAnswerDraftSource(originalText);
    }

    if (answerKind === ANSWER_KINDS.template) {
        return createTemplateAnswerDraftSource(originalText);
    }

    return createHumanAnswerDraftSource();
};

export const resolveAnswerKindForSubmit = ({
    source,
    text,
}: {
    source: AnswerDraftSource;
    text: string;
}): AnswerKind => {
    const normalizedText = text.trim();

    if (source.kind === 'ai') {
        return normalizedText === source.originalText.trim() ? ANSWER_KINDS.aiUnchanged : ANSWER_KINDS.aiChanged;
    }

    if (source.kind === 'template') {
        return normalizedText === source.originalText.trim() ? ANSWER_KINDS.template : ANSWER_KINDS.human;
    }

    return ANSWER_KINDS.human;
};
